import React, { useState } from "react";
// import { useTranslation } from "react-i18next";

import "./index-faq.css";

export default function FAQ() {
  // const { t } = useTranslation("passwordReset");

  const questions = [
    {
      question: "Para quem é o Escrita & Prática?",
      answer:
        "Para estudantes que desejam melhorar a escrita, preparar-se para o ENEM, concursos, vestibulares ou desenvolver maior segurança na produção textual.",
    },
    {
      question: "Como funciona a correção?",
      answer:
        "Você envia sua redação e recebe uma análise detalhada, comentários individualizados e orientações práticas para melhorar sua escrita.",
    },
    {
      question: "Qual o prazo para receber a correção?",
      answer:
        "O prazo pode variar de acordo com o plano contratado. As informações sobre o prazo são apresentadas no momento da contratação.",
    },
    {
      question: "Posso enviar quantas redações?",
      answer: "A quantidade de redações depende do plano ou serviço escolhido.",
    },
    {
      question: "As aulas são ao vivo?",
      answer:
        "Temos opções de aulas online e mentorias individuais. Consulte a modalidade disponível para o serviço desejado.",
    },
    {
      question: "Posso cancelar minha assinatura?",
      answer:
        "As condições de cancelamento dependem do plano contratado. Consulte os termos da contratação.",
    },
  ];

  const [open, setOpen] = useState(null);

  function toggle(index) {
    setOpen(open === index ? null : index);
  }

  return (
    <>
      <section id="faq" className="faq section">
        <div className="container faq-container">
          <div className="faq-heading section-heading">
            <h2>Perguntas frequentes</h2>

            <span></span>
          </div>

          <div className="faq-list">
            {questions.map((item, index) => (
              <div
                className={open === index ? "faq-item open" : "faq-item"}
                key={item.question}
              >
                <button className="faq-question" onClick={() => toggle(index)}>
                  <span>{item.question}</span>

                  <span className="faq-arrow">
                    {open === index ? "−" : "+"}
                  </span>
                </button>

                <div className="faq-answer">
                  <p>{item.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}